<div class="no-interaction-container">
    <div class="no-interaction-container-inner-wrapper">
      <span>Currently using settings from the template. Cannot be changed.</span>
    </div>
  </div>
